import 'jquery-validation'
import 'jquery-validation/dist/additional-methods'

import { getState } from "../helpers/getState";
import { updateCart } from "../helpers/updateCart";
import { getProduct } from "../helpers/getProduct-v6";
import { getRout } from "../helpers/getRout";
import {setContacts} from "../helpers/setContacts";
import {subscribeForm} from "../helpers/subscribeForm";

updateCart()
getRout()
subscribeForm()



getState((data) => {

  const $loader = $('.popup-loading-wrapper');

  const products = data.data.products;

  if (data.data.processing) {
    console.log('processing: ' + data.data.processing)
    $loader.show()
    routerIndex(data.data)
  } else {
    $loader.hide();
  }

  setContacts(data.data.templates)

  getProduct(products, 's-1-product');


  $loader.hide();
});
